import $ from 'jquery'

import Diagram from './Diagram'

export default class Side {
  montage

  diagram

  value

  $wrap

  constructor($wrap, montage, type) {
    this.$wrap = $wrap

    this.$wrap.on('click', '.sides-options__expander', (e) => {
      e.preventDefault()
      this.getContent().slideToggle()
    })

    this.$wrap.on('click', '.side__button-add', (e) => {
      e.preventDefault()
      this.setSides(this.getSides() + 1)
      this.updateVisibility()
    })

    this.$wrap.on('click', '.side__button-remove', (e) => {
      e.preventDefault()
      this.setSides(this.getSides() - 1)
      this.updateVisibility()
    })

    this.$wrap.on('change', 'input', (e) => {
      const $el = $(e.target)

      if ($el.hasClass('side__input--angle')) {
        const value = $el.val()

        if (value > -80 && value < 0) {
          $el.val(-80)
        } else if (value >= 0 && value < 80) {
          $el.val(80)
        }
      }

      this.updateData()
    })

    this.value = null
    this.diagram = new Diagram($('.configurator-diagram'), this)
    this.setMontage(montage)
    this.setType(type)
  }

  getSides() {
    const sides = this.$wrap.find('.sides-options__sides').val()

    return sides === '' ? 0 : parseInt(sides, 10)
  }

  setSides(sides) {
    this.$wrap.find('.sides-options__sides').val(sides === 0 ? '' : `${sides}`)
  }

  getContent() {
    return this.$wrap.find('.sides-options__content')
  }

  expand() {
    this.getContent().slideDown()
  }

  setMontage(montage) {
    if (this.montage === montage) {
      return
    }

    this.montage = montage
    this.updateData()
  }

  setType(value) {
    if (this.value === value) {
      return
    }

    this.value = value

    this.$wrap.find('.sides-options__unavailable').toggle(!value)
    this.$wrap.find('.sides-options__available').toggle(!!value)

    let sides = this.getSides()

    switch (value) {
      case 'i-form':
        sides = 1
        break
      case 'l-form':
        sides = 2
        break
      case 'u-form':
        sides = 3
        break
      case 'freiform':
        sides = Math.max(1, sides)
        break
      default:
        sides = 0
        break
    }

    this.$wrap.find('.sides-options__sides').val(sides === 0 ? '' : sides)
    this.updateVisibility()
  }

  updateVisibility() {
    const sides = this.getSides()
    const showButtons = this.value === 'freiform'
    const oneSided = sides === 1

    this.$wrap
      .find(
        '.sides-options__table th:last-child, .sides-options__table td:last-child',
      )
      .toggle(!oneSided || showButtons)

    this.$wrap.find('.sides-options__table .side').each((i, el) => {
      const visible = i < sides
      const last = i === sides - 1
      const lastOrAfter = i >= sides - 1

      $(el).toggle(visible)
      $(el).find('.side__length .side__input').prop('disabled', !visible)
      $(el).find('.side__angle .side__input').prop({
        disabled: lastOrAfter,
        hidden: lastOrAfter,
      })
      $(el).find('.side__angle .side__angle-wrapper').prop({
        hidden: lastOrAfter,
      })

      $(el)
        .find('.side__button')
        .toggle(showButtons && last)
    })

    this.updateData()
  }

  updateData() {
    const data = {
      visible: this.montage && this.value,
      segments: [],
      montage: this.montage,
    }

    if (data.visible) {
      this.$wrap.find('.sides-options__table .side').each((i, el) => {
        const $length = $(el).find('.side__length .side__input')
        const $angle = $(el).find('.side__angle .side__input')

        if (!$length.prop('disabled')) {
          data.segments.push({
            length: +$length.val(),
            angle: $angle.prop('disabled') ? null : +$angle.val(),
          })
        }
      })
    }

    this.diagram?.update(data)
  }
}
